// 借入申込確認画面
import React from 'react';
import TopArea from '../../molecules/TopArea';
import Reception from '../../templates/Reception';
import {
  ParentShelf,
  ChildShelf,
  Content,
  GuarantorInfo,
  StepNavigation as StepType,
} from '../../types/Template';
import LoadingModal from '../../molecules/LoadingModal';
import MypageReturn from '../../molecules/MypageReturn';
import FooterBorrowingApplicationConfirmation from '../../organisms/FooterBorrowingApplicationConfirmation';
import FileUpload from '../../templates/FileUpload';
import { ShelfInfo, SetShelfInfo, ShelfInfoObj } from '../../types/FileUpload';
import { KeyValue } from '../../types/KeyValue';
import AgreementInfo from '../../templates/AgreementInfo';

interface Props {
  step_navigation: StepType;
  reception_cd: string;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  looks_inactive: boolean;
  parent_shelfs: ParentShelf[];
  child_shelfs: ChildShelf[];
  contents: Content[];
  setParentShelfs: React.Dispatch<React.SetStateAction<ParentShelf[]>>;
  setChildShelfs: React.Dispatch<React.SetStateAction<ChildShelf[]>>;
  setContents: React.Dispatch<React.SetStateAction<Content[]>>;
  is_staff: boolean;
  status_code: number;
  shelf_info: ShelfInfoObj;
  setShelfInfo: SetShelfInfo;
  reception_sub_cd: string;
  ident_lv1_cd: string;
  ident_lv2_cd: string;
  ident_lv3_cd: string;
  agreement_info: KeyValue[];
  guarantors_num: number;
  is_loading: boolean;
  display_status: boolean;
  show_error_nav: boolean;
  has_debtor: boolean;
  handleClickDecline: () => Promise<any>;
  handleClickResendMail: () => void;
  reception_id: number;
  callApi: (function_name: string) => Promise<any>;
  handleClickChangeDetails: () => Promise<any>;
  setIsLoading: (flag: boolean) => void;
  guarantor_info: GuarantorInfo;
  is_secured: boolean;
  is_unsecured: boolean;
  is_agricultural_modernization_funds: boolean;
}

const BorrowingApplicationConfirmation: React.FC<Props> = ({
  step_navigation,
  label,
  status_name,
  display_reception_cd,
  guide_text,
  looks_inactive,
  shelf_info,
  setShelfInfo,
  reception_id,
  reception_cd,
  reception_sub_cd,
  ident_lv1_cd,
  ident_lv2_cd,
  ident_lv3_cd,
  agreement_info,
  parent_shelfs,
  child_shelfs,
  contents,
  setParentShelfs,
  setChildShelfs,
  setContents,
  is_staff,
  guarantors_num,
  is_loading,
  display_status,
  show_error_nav,
  has_debtor,
  handleClickDecline,
  handleClickResendMail,
  status_code,
  callApi,
  handleClickChangeDetails,
  setIsLoading,
  guarantor_info,
  is_secured,
  is_unsecured,
  is_agricultural_modernization_funds,
}) => {
  return (
    <>
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />
      <Reception
        parent_shelfs={parent_shelfs}
        child_shelfs={child_shelfs}
        contents={contents}
        setParentShelfs={setParentShelfs}
        setChildShelfs={setChildShelfs}
        setContents={setContents}
        looks_inactive={looks_inactive}
        guarantors_num={guarantors_num}
        show_error_nav={show_error_nav}
        callApi={callApi}
        guarantor_info={guarantor_info}
      />
      <FileUpload
        shelf_info={shelf_info}
        setShelfInfo={setShelfInfo}
        reception={{
          reception_id: reception_id,
          reception_cd: reception_cd,
          reception_sub_cd: reception_sub_cd,
          ident_lv1_cd: ident_lv1_cd,
          ident_lv2_cd: ident_lv2_cd,
          ident_lv3_cd: ident_lv3_cd,
          status_code: status_code,
        }}
        looks_inactive={looks_inactive}
        guarantors_num={guarantors_num}
        guarantor_info={guarantor_info}
        is_secured={is_secured}
        is_unsecured={is_unsecured}
        is_agricultural_modernization_funds={is_agricultural_modernization_funds}
      />
      {/* 連帯債務者等が0人の場合は非表示、1人以上の場合は表示する */}
      {guarantors_num !== 0 && <AgreementInfo agreement_info={agreement_info} />}
      <FooterBorrowingApplicationConfirmation
        has_debtor={has_debtor}
        handleClickDecline={handleClickDecline}
        handleClickResendMail={handleClickResendMail}
        reception_cd={reception_cd}
        reception_id={reception_id}
        status_code={status_code}
        handleClickChangeDetails={handleClickChangeDetails}
        setIsLoading={setIsLoading}
      />
      <MypageReturn is_staff={is_staff} />
      <LoadingModal show={is_loading} />
    </>
  );
};

export default BorrowingApplicationConfirmation;
